import { keyBy } from 'lodash';

import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import {
  baseFiltersOptions,
  type DateFilters,
  type FilterSelectType,
  type FilterType,
} from '~/components/FiltersMenu/types';
import { getFilterProps } from '~/components/FiltersMenu/utils/getFilterProps';
import { type SelectedFilter } from '~/store/filters/types';

export const getDateFiltersOptions = ({
  selectedFilters,
  dateFilters,
  onSelect,
  disabledFilters,
}: {
  selectedFilters: SelectedFilter[];
  dateFilters: DateFilters[];
  onSelect: FilterSelectType;
  disabledFilters?: FilterType[];
}) => {
  const selectedFiltersTypes = keyBy(selectedFilters, 'type');

  const options: DropdownMenuOption[] = dateFilters.map((dateFilter) => ({
    ...getFilterProps({
      type: dateFilter,
      onSelect,
      isSelected: !!selectedFiltersTypes[dateFilter],
      disabled: disabledFilters?.includes(dateFilter),
    }),
    label: baseFiltersOptions[dateFilter].label,
    prefix: null,
    type: 'item',
  }));

  return options;
};
